import { useEffect, useState } from 'react';
import {
  scheduleTime,
  scheduleTimeForFirstStep,
  immediateDelay,
} from '@/constants/outreach-delay-time';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const getDelayById = (stepInterval) => {
  const delay = [
    ...scheduleTime,
    ...scheduleTimeForFirstStep,
    ...immediateDelay,
  ];
  return delay.find((time) => time.value === stepInterval);
};

export const useDelay = ({ outreach = {}, step = {} }) => {
  const { firstStepDelay } = useFlags();
  const [delayOption, setDelayOption] = useState([]);
  const firstDelay = { label: `${firstStepDelay} Mins`, value: firstStepDelay };

  useEffect(() => {
    if (!outreach?.steps?.length || step?.step === 1) {
      // Add the delay from flag in options, Only if its not 10 or 60 as its been already added for all customers by default, Still keeping this flag for testing use case
      const delaysforFirstStep =
        firstStepDelay !== 60 && firstStepDelay !== 10
          ? [firstDelay, ...scheduleTimeForFirstStep]
          : [...scheduleTimeForFirstStep];
      setDelayOption(delaysforFirstStep);
      return;
    }
    const lastStep = outreach?.steps[outreach?.steps?.length - 1];
    if (!step?.id && lastStep?.channel !== step?.channel) {
      setDelayOption([...immediateDelay, ...scheduleTime]);
      return;
    }
    const currStepIndex = outreach?.steps.findIndex(
      (currStep) => currStep?.id === step?.id
    );
    const prevStep = outreach?.steps[currStepIndex - 1];
    if (step?.id && prevStep?.channel !== step?.channel) {
      setDelayOption([...immediateDelay, ...scheduleTime]);
      return;
    }
    setDelayOption(scheduleTime);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return delayOption;
};
